document.addEventListener('DOMContentLoaded', function() {
  const footerBlocks = document.querySelectorAll('.footer-block');
  const mediaQuery = window.matchMedia('(max-width: 1024px)');
  
  // Función para manejar el acordeón
  function handleAccordion(e) {
    const header = e.currentTarget;
    const block = header.closest('.footer-block');
    const content = block.querySelector('.footer-block__details-content');
    
    if (mediaQuery.matches) {
      block.classList.toggle('footer-block--expanded');
      
      if (block.classList.contains('footer-block--expanded')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '0px';
      }
    }
  }

  // Función para reiniciar estados cuando la pantalla es mayor a 1024px
  function resetAccordions(e) {
    if (!e.matches) { // si la pantalla es mayor a 1024px
      footerBlocks.forEach(block => {
        const content = block.querySelector('.footer-block__details-content');
        block.classList.remove('footer-block--expanded');
        content.style.maxHeight = '';
      });
    }
  }

  // Añadir event listeners
  footerBlocks.forEach(block => {
    const header = block.querySelector('.footer-header-container');
    if (header) {
      header.addEventListener('click', handleAccordion);
    }
  });

  // Escuchar cambios en el tamaño de la pantalla
  mediaQuery.addEventListener('change', resetAccordions);
  
  // Ejecutar reset inicial si es necesario
  resetAccordions(mediaQuery);
});